var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stat-card',{attrs:{"title":"GST Retained","color":"deep-purple lighten-5","amount":_vm.total,"icon":"restore","sub_title":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }